


























//@mouseover="hover = !userIsAdmin"
import {Vue, Component, Prop, Mixins} from 'vue-property-decorator';
import {DateTime} from 'luxon';
import {nil, POST_STATUS} from '@/common';
import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
@Component({
    components: {
    },
})
export default class PostListing extends Mixins(UserRoleMixin) {
    @Prop({default: ()=>null})
    post!: any;
    @Prop({default: 'https://picsum.photos/500'})
    //@Prop({default: ''})
    image!: string;

    public hover = false;

    public get title(){
        if(nil(this.post)) return '';
        return this.post.title;
    }
    public get summary() {
        if(nil(this.post)) return '';
        return this.post.body;
    }
    public get author(){
        if(nil(this.post) || nil(this.post.authorName, true)) return 'SoPlush Beauty';
        return this.post.authorName;
    }
    public get date(){
        if(nil(this.post)) return '';
        return DateTime.fromISO(this.post.date).toLocaleString(DateTime.DATETIME_MED);
    }
    public get currentElevation(){
        return this.hover ? 6 : 0;
    }
    public get postId(){
        if(nil(this.post)) return '';
        return this.post._id;
    }

    public get trashed(){
        return (!nil(this.post) && this.post.status === POST_STATUS.TRASHED)

    }
    public get published(){
        return (!nil(this.post) && this.post.status === POST_STATUS.PUBLISHED)

    }
    public get drafted(){
        return (!nil(this.post) && this.post.status === POST_STATUS.DRAFT)

    }
}
